module.exports = __webpack_public_path__ + "static/fonts/Fact-Light.6bbbc09.ttf";